module.exports = __webpack_public_path__ + "media/Ring 8.53863023.mp3";